/**
 * Opt-in planner timing instrumentation.
 *
 * Disabled unless `localStorage.ebsPerf = '1'` (or `?ebsPerf=1` once, which
 * persists the flag), so it costs nothing in normal use.
 */

let enabled: boolean | undefined;

export function perfEnabled(): boolean {
  if (enabled === undefined) {
    enabled = false;
    try {
      const fromQuery = new URLSearchParams(window.location.search).get('ebsPerf');
      if (fromQuery !== null) {
        window.localStorage.setItem('ebsPerf', fromQuery);
      }
      enabled = window.localStorage.getItem('ebsPerf') === '1';
    } catch {
      enabled = false;
    }
  }
  return enabled;
}

export function perfLog(label: string, detail?: Record<string, unknown>): void {
  if (!perfEnabled()) return;
  // eslint-disable-next-line no-console
  console.log(`[perf] ${label}`, detail ?? '');
}

/** Starts a timer; call the returned function to log the elapsed milliseconds. */
export function perfStart(label: string): (detail?: Record<string, unknown>) => void {
  if (!perfEnabled()) return () => undefined;
  const t0 = performance.now();
  return (detail?: Record<string, unknown>) => {
    perfLog(label, { ms: Math.round(performance.now() - t0), ...(detail ?? {}) });
  };
}
